import React, { useState, lazy } from 'react';
import styles from '../styles/famlilyTracking.module.css';
import useMediaQuery from '../../../hooks/useMediaQuery';

const PhoneVerificationComponent = lazy(() => import('../../../components/sharedComponents/PhoneVerification'));


const FamilyTrackingHero = ({ showCheckoutPopup }) => {

    const isAboveMediumScreens = useMediaQuery("(min-width: 500px)");

    const [toggleSearchInput, setToggleSearchInput] = useState(true);

    const togglePhoneVerificationPopup = (e) => {
        e.preventDefault();
        setToggleSearchInput(!toggleSearchInput);
    }

    return (
        <section>
            <div className={styles.heroBgImage}>
                <div className={styles.homeHeroInnerContainer}>
                    <div className='maxScreen'>
                        {!isAboveMediumScreens && <div className={styles.emptyContainer}></div>}
                        <div className={styles.heroContainer}>
                            <h1 className={styles.heading}><span className="hightLightText">Stay In Control</span>
                                <br></br>With The World’s  #1<br></br>Family Tracking App</h1>
                            <p className={styles.paragraph}>
                                Modern families are complicated. Device Tracker
                                Plus makes things simple. With real-time family tracking
                                and smart safety features, you’ll always know where
                                your loved ones are and that they’re safe. </p>
                            <br />
                            <br />
                            <div className='inputContainer'>
                                {toggleSearchInput && <PhoneVerificationComponent showPopUp={togglePhoneVerificationPopup} />}
                            </div>

                        </div>
                        <div className={styles.emptyContainer}></div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default FamilyTrackingHero;